import React from 'react'
import './Orientation.scss'

export default function OrientationOverlay({text, icon}){
    return <div className='orientation-overlay'>
        {icon && <img src={icon} alt=""/>}
        {text && <h1>{text}</h1>}
    </div>
}